module.exports = __webpack_public_path__ + "img/spain-transport-accidents-female.67a6035a.png";